module.exports = __webpack_public_path__ + "img/img.3b72f717.png";